import type { SiteConfig } from '../../../siteContentTypes.ts';
import { ColorField, NumberField, SelectField, TextField } from './fields.tsx';

export function BrandingSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const b = config.branding;
  const setColors = (patch: Partial<SiteConfig['branding']['colors']>) =>
    update({ branding: { ...b, colors: { ...b.colors, ...patch } } });
  const setTypography = (patch: Partial<SiteConfig['branding']['typography']>) =>
    update({ branding: { ...b, typography: { ...b.typography, ...patch } } });
  const setStyle = (patch: Partial<SiteConfig['branding']['style']>) =>
    update({ branding: { ...b, style: { ...b.style, ...patch } } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Identité visuelle</h2>

      <h3 style={{ fontSize: 14, fontWeight: 800, marginBottom: 10 }}>Couleurs</h3>
      <ColorField label="Couleur primaire" value={b.colors.primary} onChange={(v) => setColors({ primary: v })} />
      <ColorField label="Couleur secondaire" value={b.colors.secondary} onChange={(v) => setColors({ secondary: v })} />
      <ColorField label="Couleur d'accent" value={b.colors.accent} onChange={(v) => setColors({ accent: v })} />
      <ColorField label="Couleur du texte des boutons" value={b.colors.buttonText} onChange={(v) => setColors({ buttonText: v })} />
      <ColorField label="Texte principal" value={b.colors.textPrimary} onChange={(v) => setColors({ textPrimary: v })} />
      <ColorField label="Texte secondaire" value={b.colors.textSecondary} onChange={(v) => setColors({ textSecondary: v })} />
      <ColorField label="Fond" value={b.colors.background} onChange={(v) => setColors({ background: v })} />
      <ColorField label="Fond des cartes" value={b.colors.cardBackground} onChange={(v) => setColors({ cardBackground: v })} />
      <ColorField label="Bordures" value={b.colors.border} onChange={(v) => setColors({ border: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Typographie</h3>
      <TextField label="Police principale" value={b.typography.primaryFont} onChange={(v) => setTypography({ primaryFont: v })} />
      <NumberField label="Taille H1 (px)" value={b.typography.h1Size} onChange={(v) => setTypography({ h1Size: v })} />
      <NumberField label="Taille H2 (px)" value={b.typography.h2Size} onChange={(v) => setTypography({ h2Size: v })} />
      <NumberField label="Taille H3 (px)" value={b.typography.h3Size} onChange={(v) => setTypography({ h3Size: v })} />
      <NumberField label="Taille du texte (px)" value={b.typography.bodySize} onChange={(v) => setTypography({ bodySize: v })} />
      <NumberField label="Hauteur de ligne" value={b.typography.lineHeight} onChange={(v) => setTypography({ lineHeight: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Style général</h3>
      <NumberField label="Rayon des bordures (px)" value={b.style.borderRadius} onChange={(v) => setStyle({ borderRadius: v })} />
      <SelectField
        label="Style des boutons"
        value={b.style.buttonStyle}
        onChange={(v) => setStyle({ buttonStyle: v })}
        options={[
          { value: 'rounded', label: 'Arrondi' },
          { value: 'pill', label: 'Pilule' },
          { value: 'square', label: 'Carré' },
        ]}
      />
      <SelectField
        label="Espacement général"
        value={b.style.spacing}
        onChange={(v) => setStyle({ spacing: v })}
        options={[
          { value: 'compact', label: 'Compact' },
          { value: 'comfortable', label: 'Confortable' },
          { value: 'spacious', label: 'Spacieux' },
        ]}
      />
      <NumberField label="Largeur maximale du contenu (px)" value={b.style.maxWidth} onChange={(v) => setStyle({ maxWidth: v })} />
    </div>
  );
}
